import * as Yup from 'yup'
import {ID, Response} from '../../../../../../_metronic/helpers'
import { Account } from '../../../account/accounts-list/core/_models'
import { initialUser, User } from '../../../user/users-list/core/_models'
import { Enrollment, initialEnrollment } from '../../../enrollment/enrollments-list/core/_models'
import { StudentType } from '../../../student-type/student-types-list/core/_models'
import { FieldTProps } from '../../../../../../_component/Form'
export type Student = {
  id?: ID
  admission_no?: string
  admission_date?: Date
  relation_with_guardian?: string
  registration_no?: string
  group?: string
  is_library_member?: boolean
  is_hostel_member?: boolean
  is_transport_member?: boolean
  previous_school?: string
  previous_class?: string
  transfer_certificate?: string
  status?: 'regular' | 'drop' | 'transfer' | 'passed' | 'new' | 'waiting' | 'declined' | 'approved'
  created_at?: Date
  updated_at?: Date
  deleted_at?: Date
  created_by?: string
  updated_by?: string
  father_id?: number
  mother_id?: number
  guardian_id?: number
  account_id?: number
  school_id?: string
  student_type_id?: number
  discount_id?: number
  enrollment_id?: number
  account?: Account
  father?: User
  mother?: User
  guardian?: User
  enrollment?: Enrollment
  student_type?: StudentType
  account_user_image_to_upload?: File
  guardian_image_to_upload?: File
  father_image_to_upload?: File
  mother_image_to_upload?: File
  transfer_certificate_to_upload?: File
}

export type StudentsQueryResponse = Response<Array<Student>>

export const initialStudent: Student = {
  admission_no: '',
  admission_date: new Date(),
  registration_no: '',
  previous_school: '',
  previous_class: '',
  relation_with_guardian: undefined,
  account: {user: {...initialUser, status: false}},
  father: {...initialUser},
  mother: {...initialUser},
  guardian: {...initialUser,  
    status: false},
  enrollment: {...initialEnrollment},
}

export const studentSchemas = [
  Yup.object({
    account: Yup.object().shape({
      user: Yup.object().shape({
        first_name: Yup.string().required().label('First Name'),
        last_name: Yup.string().required().label('Last Name'),
        other_name: Yup.string(),
        email: Yup.string().email().label('Email'),
        phone: Yup.string(),
        gender: Yup.string().required().label('Gender'),
        birthday: Yup.date(),
        blood_group: Yup.string(),
        religion: Yup.string(),
        caste: Yup.string(),
        national_id: Yup.string(),
        address1: Yup.string().required().label('Address'),
        address2: Yup.string(),
        status: Yup.boolean(),
      }),
    }),
  }),
  Yup.object({
    guardian: Yup.object().shape({
      first_name: Yup.string().required().label('First Name'),
      last_name: Yup.string().required().label('Last Name'),
      email: Yup.string().required().email().label('Email'),
      phone: Yup.string().required().label('Phone Number'),
      highest_education: Yup.string(),
      id: Yup.number(),
      profession: Yup.string(),
      national_id: Yup.string(),
      file: Yup.string(),
      address1: Yup.string().required().label('Address'),
      address2: Yup.string(),
      status: Yup.boolean(),
    }),
    relation_with_guardian: Yup.string().required().label('Relationship with Student'),
  }),
  Yup.object({
    father: Yup.object().shape({
      first_name: Yup.string().required().label('First Name'),
      last_name: Yup.string().required().label('Last Name'),
      email: Yup.string().email().label('Email'),
      phone: Yup.string(),
      highest_education: Yup.string(),
      id: Yup.number(),
      profession: Yup.string(),
      relationship: Yup.string(),
      file: Yup.string(),
    }),
  }),
  Yup.object({
    mother: Yup.object().shape({
      first_name: Yup.string().required().label('First Name'),
      last_name: Yup.string().required().label('Last Name'),
      email: Yup.string().email().label('Email'),
      phone: Yup.string(),
      highest_education: Yup.string(),
      id: Yup.number(),
      profession: Yup.string(),
      relationship: Yup.string(),
      file: Yup.string(),
    }),
  }),
  Yup.object().shape({
    admission_no: Yup.string(),
    admission_date: Yup.date(),
    registration_no: Yup.string(),
    group: Yup.string(),
    previous_school: Yup.string(),
    previous_class: Yup.string(),
    transfer_certificate: Yup.string(),
    student_type_id: Yup.number().required().label('Student Type'),
    enrollment: Yup.object().shape({
      class_id: Yup.number().required().label('Class'),
      section_id: Yup.number().required().label('Section'),
    }),
  }),
]


export const fields: (formik?: any) => FieldTProps[] = (formik = {values: {}}) => [
  {
    title: 'Student Info',
    fields: [
      {
        name: 'account.user.email',
        label: 'Email',
        type: 'email',
        // optionsQuery: {
        //   queryKey: ['account.user', 'filter={"status":true}'],
        //   enabled: true,
        //   name: 'account.user.email',
        // },
        required: true,
        full: false,
        table: true,
      },
      {
        name: 'account.user.first_name',
        label: 'First Name',
        required: true,
        full: false,
        table: true,
      },
      {
        name: 'account.user.last_name',
        label: 'Last Name',
        required: true,
        full: false,
        table: true,
      },
      {name: 'account.user.other_name', label: 'Other Name', type: 'text', full: false},
      {
        name: 'account.user.phone',
        label: 'Phone',
        required: true,
        full: false,
      },
      {
        name: 'account.user.gender',
        label: 'Gender',
        type: 'select',
        options: [
          {label: 'Male', value: 'male'},
          {label: 'Female', value: 'female'},
        ],
        required: true,
        full: false,
      },
      {name: 'account.user.birthday.', label: 'Birthday', type: 'date', full: false},
      {
        name: 'account.user.blood_group',
        label: 'Blood Group',
        type: 'select',
        options: [
          {label: 'A+', value: 'A+'},
          {label: 'A-', value: 'A-'},
          {label: 'B+', value: 'B+'},
          {label: 'B-', value: 'B-'},
          {label: 'AB+', value: 'AB+'},
          {label: 'AB-', value: 'AB-'},
          {label: 'O+', value: 'O+'},
          {label: 'O-', value: 'O-'},
        ],
        full: false,
      },
      {
        name: 'account.user.religion',
        label: 'Religion',
        type: 'select',
        options: [
          {label: 'Christianity', value: 'CHRISTIANITY'},
          {label: 'Islam', value: 'ISLAM'},
          {label: 'Prefer not to say', value: 'PREFER_NOT_TO_SAY'},
        ],
        full: false,
      },
      {name: 'account.user.caste', label: 'Caste', type: 'text', full: false},
      {name: 'account.user.national_id', label: 'National ID', type: 'text', full: false},
      {
        name: 'account.user.image',
        label: 'Image',
        type: 'image',
        required: false,
        full: false,
        table: false,
        sortable: false,
      },
      {
        name: 'account.user.address1',
        label: 'Present Address',
        type: 'textarea',
        required: true,
        full: false,
      },
      {name: 'account.user.address2', label: 'Permanent Address', type: 'textarea', full: false},
    ],
  },

  {
    title: 'Guardian Info',
    fields: [
      {
        name: 'guardian.email',
        label: 'Guardian Email',
        type: 'email',
        component: 'GetUser',
        required: true,
        full: false,
      },
      {
        name: 'guardian.first_name',
        label: 'Guardian First Name',
        type: 'text',
        required: true,
        full: false,
      },
      {
        name: 'guardian.last_name',
        label: 'Guardian Last Name',
        type: 'text',
        required: true,
        full: false,
      },
      {name: 'guardian.phone', label: 'Guardian Phone', type: 'text', required: true, full: false},
      {
        name: 'relation_with_guardian',
        label: 'Relationship With Student',
        type: 'select',
        required: true,
        options: [
          {label: 'Father', value: 'father'},
          {label: 'Mother', value: 'mother'},
          {label: 'Other', value: 'other'},
        ],
        full: false,
      },
      {name: 'guardian.national_id', label: 'National ID', type: 'text', full: false},
      {name: 'guardian.highest_education', label: 'Highest Education', type: 'text', full: false},
      {name: 'guardian.profession', label: 'Profession', type: 'text', full: false},
      {
        name: 'guardian.status',
        label: 'Activate Login Account',
        type: 'switch',
        full: false,
        condition: () => !formik?.values?.isExternal,
      },
      {
        name: 'guardian.image',
        label: 'Guardian Image',
        type: 'image',
        full: false,
      },
      {
        name: 'guardian.same_as_student_address',
        label: 'Same as student address?',
        type: 'checkbox',
        onchecked: (_e: any, formik: any) => {
          const isChecked = _e.target.checked
          const studentAddr1 = formik.values?.account?.user?.address1 || ''
          const studentAddr2 = formik.values?.account?.user?.address2 || ''

          formik.setFieldValue('guardian.address1', isChecked ? studentAddr1 : '')
          formik.setFieldValue('guardian.address2', isChecked ? studentAddr2 : '')
        },
        full: true,
      },
      {
        name: 'guardian.address1',
        label: 'Guardian Present Address',
        type: 'textarea',
        required: true,
        full: false,
      },
      {
        name: 'guardian.address2',
        label: 'Guardian Permanent Address',
        type: 'textarea',
        full: false,
      },
    ],
  },

  {
    title: 'Father Info',
    fields: [
      {
        name: 'father.email',
        label: 'Father Email',
        type: 'text',
        // component: isExternal ? undefined : GetUser,
        full: false,
      },
      {name: 'father.first_name', label: 'Father First Name', type: 'text', required: true},
      {name: 'father.last_name', label: 'Father Last Name', type: 'text', required: true},
      {name: 'father.phone', label: 'Father Phone', type: 'text'},
      {name: 'father.highest_education', label: 'Father Highest Education', type: 'text'},
      {name: 'father.profession', label: 'Father Profession', type: 'text'},
      {
        name: 'father.image',
        label: 'Father Image',
        type: 'image',
      },
    ],
  },
  {
    title: 'Mother Info',
    fields: [
      {
        name: 'mother.email',
        label: 'Mother Email',
        type: 'email',
        // component: isExternal ? undefined : GetUser,
        full: false,
      },
      {name: 'mother.first_name', label: 'Mother First Name', type: 'text', required: true},
      {name: 'mother.last_name', label: 'Mother Last Name', type: 'text', required: true},
      {name: 'mother.phone', label: 'Mother Phone', type: 'text'},
      {name: 'mother.highest_education', label: 'Mother Highest Education', type: 'text'},
      {name: 'mother.profession', label: 'Mother Profession', type: 'text'},
      {
        name: 'mother.image',
        label: 'Mother Image',
        type: 'image',
      },
    ],
  },
  {
    title: 'Enrollment Info',
    fields: [
      {
        name: 'admission_no',
        label: 'Admission Number',
        type: 'text',
        required: false,
        table: true,
      },
      {
        name: 'admission_date',
        label: 'Admission Date',
        type: 'date',
        required: false,
        table: true,
      },
      {
        name: 'registration_no',
        label: 'Registration Number',
        type: 'text',
        required: false,
      },
      {
        name: 'student_type_id',
        label: 'Student Type',
        viewName: 'student_type.type',
        type: 'select',
        optionsQuery: {
          queryKey: ['student-type', 'filter={"status":true}'],
          enabled: true,
          name: 'type',
        },
        required: true,
        table: true,
      },
      {
        name: 'enrollments.class_id',
        label: 'Class',
        viewName: 'enrollments.class.name',
        type: 'select',
        optionsQuery: {
          queryKey: ['class', 'filter={"status":true}'],
          enabled: true,
        },
        required: true,
        table: false,
      },
      {
        name: 'student.enrollments.section_id',
        label: 'Section',
        viewName: 'enrollments.section.name',
        type: 'select',
        optionsQuery: {
          queryKey: [
            'section',
            `filter={"status":true,"class_id":${formik.values?.enrollments?.class_id}}`,
          ],
          enabled: !!formik.values?.enrollments?.class_id,
        },
        required: true,
      },
      {
        name: 'group',
        label: 'Group',
        type: 'select',
        options: [
          {label: 'Science', value: 'science'},
          {label: 'Art', value: 'art'},
          {label: 'Commerce', value: 'commerce'},
        ],
      },
      {
        name: 'previous_school',
        label: 'Previous School',
        type: 'text',
      },
      {
        name: 'previous_class',
        label: 'Previous Class',
        type: 'text',
      },
      {
        name: 'transfer_certificate',
        label: 'Transfer Certificate',
        type: 'files',
        accept: '.pdf, .doc, .docx, .ppt, .pptx',
        limit: 2048,
      },
      {
        name: 'status',
        label: 'Status',
        type: 'select',
        options: [
          {label: 'Regular', value: 'regular'},
          {label: 'Drop', value: 'drop'},
          {label: 'Transfer', value: 'transfer'},
          {label: 'Passed', value: 'passed'},
        ],
        visible: !!formik.values?.id,
        table: true,
      },
    ],
  },
]
